export default ({tempList = false}) => [
  {
    numeric: false,
    bool:true,
    disablePadding: true,
    label: 'Integ.',
    id: 'indNaoIntegrado',
    hide: tempList
  },
  {
    numeric: false,
    disablePadding: false,
    label: 'Data',
    id: 'dataHoraInicio',
    format: 'DD/MM/YYYY ',
  },
  {
    numeric: false,
    disablePadding: true,
    label: 'Hr Inicio',
    id: 'date',
    field: 'dataHoraInicio',
    format: 'HH:mm',
  },
  {
    numeric: false,
    disablePadding: true,
    label: 'Hr Fim',
    id: 'dataHoraFim',
    format: 'HH:mm',
  },
  {
    numeric: false,
    disablePadding: true,
    label: 'Projeto',
    id: 'codigoProjeto'
  },
  {
    numeric: false,
    disablePadding: true,
    label: 'Subsistema',
    id: 'codigoSubsistema'
  },
  // {
  //   numeric: false,
  //   disablePadding: true,
  //   label: 'Cod. Subsistema',
  //   id: 'codigoSubsistema'
  // },
  {
    numeric: false,
    disablePadding: true,
    label: 'Pendência',
    id: 'pendenciaId'
  },
  {
    numeric: false,
    disablePadding: true,
    label: 'Atividade Alocada',
    id: 'atividadeAlocada'
  },
  {
    numeric: false,
    disablePadding: true,
    label: 'Descrição',
    id: 'descricao'
  },
  {
    numeric: false,
    disablePadding: true,
    label: 'Classif',
    id: 'codigoClassificacaoHoras'
  },
  {
    numeric: false,
    disablePadding: true,
    label: 'Tipo',
    id: 'codigoTipoAtividade'
  },
  {
    numeric: false,
    disablePadding: true,
    label: 'Tipo de Capacitação',
    id: 'descTipoCapacitacao',
    hide: tempList
  },
  {
    numeric: false,
    disablePadding: true,
    label: 'Centro de Custo',
    id: 'centroCusto'
  },
]